
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title>
                    {{$t('menus.reversements_configs')}}
                    <v-spacer></v-spacer>
                    <!--<v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>-->
                </v-card-title>
                <v-data-table :headers="headers" :items="(reversements_configs)?reversements_configs.palier_configs:[]" :search="search" sort-by="name" class="elevation-1" :loading="reversements_configs===undefined" loading-text="Chargement en cours...">
                  <template v-slot:top>
                    <div style="padding:15px">
                      <v-progress-linear
                              :active="reversing"
                              :indeterminate="reversing"
                              absolute
                              top
                              color="primary"
                      ></v-progress-linear>
                      <v-alert dense text type="success" dismissible v-if="responseError==='success'">
                        {{responseMessage}}
                      </v-alert>
                      <v-alert dense outlined type="error" dismissible v-if="responseError==='error'">
                       {{responseMessage}}
                      </v-alert>
                      <v-btn   style="background: #29b3a6;color: #fff"
                               @click.prevent="performReversements('bystep')" class="mb-2 float-right btn-custom-add">
                        {{$t('reversements.perform')}}
                      </v-btn>
                    </div>
                    <v-toolbar flat color="white">
                      <v-spacer></v-spacer>
                      <v-dialog v-model="dialogNote" max-width="500px">
                        <v-card>
                          <v-card-title>
                            <span class="headline">{{$t('comment')}}</span>
                          </v-card-title>

                          <v-card-text>

                            {{note}}

                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click.prevent="closeNote()">{{$t('close')}}</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>


                    </v-toolbar>
                    <v-dialog v-model="dialogShowDetail" max-width="60%">
                      <v-card>
                        <v-card-title>
                          <span class="headline"> {{detailuser._company}} </span>
                        </v-card-title>

                        <v-card-text>
                          <v-list >

                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title style="color: #29B3A6; font-weight: bold">{{$t("usersmeanspaiementconfirmation.company")}}</v-list-item-title>
                                <v-list-item-subtitle>{{detailuser._company}}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>

                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title style="color: #29B3A6; font-weight: bold">{{$t("usersmeanspaiementconfirmation.acronyme")}}</v-list-item-title>
                                <v-list-item-subtitle>{{detailuser._acronyme}}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title style="color: #29B3A6; font-weight: bold">{{$t("usersmeanspaiementconfirmation.email")}}</v-list-item-title>
                                <v-list-item-subtitle>{{detailuser._email}}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>

                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title style="color: #29B3A6; font-weight: bold">{{$t("usersmeanspaiementconfirmation.web_site")}}</v-list-item-title>
                                <v-list-item-subtitle>{{detailuser._web_site}}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>

                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title style="color: #29B3A6; font-weight: bold">{{$t("usersmeanspaiementconfirmation.base_url_site_web")}}</v-list-item-title>
                                <v-list-item-subtitle>{{detailuser._base_url_site_web}}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>

                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title style="color: #29B3A6; font-weight: bold">{{$t("usersmeanspaiementconfirmation.user")}}</v-list-item-title>
                                <v-list-item-subtitle>{{ (detailuser._user_id)?detailuser._user_id._last_name:'--'}} {{ (detailuser._user_id)?detailuser._user_id._first_name:'--'}} </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title style="color: #29B3A6; font-weight: bold">{{$t("usersmeanspaiementconfirmation.categorie_id")}}</v-list-item-title>
                                <v-list-item-subtitle>{{ (detailuser._categorie_id)?detailuser._categorie_id._description:'--'}}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>

                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title style="color: #29B3A6; font-weight: bold">{{$t("usersmeanspaiementconfirmation.country")}}</v-list-item-title>
                                <v-list-item-subtitle>{{ (detailuser.country)?detailuser.country._name:'--'}}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>

                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title style="color: #29B3A6; font-weight: bold">{{$t("usersmeanspaiementconfirmation.valide")}}</v-list-item-title>
                                <v-list-item-subtitle>

                                  <v-chip color="primary" v-if="detailuser._valide">
                                    {{$t("usersmeanspaiementconfirmation.validedo")}}
                                  </v-chip>
                                  <v-chip color="warning" v-else>
                                    {{$t("usersmeanspaiementconfirmation.validenot")}}
                                  </v-chip>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                          </v-list>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn class="dark" text @click="dialogShowDetail = false">{{$t("close")}}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                  <template v-slot:item._send_mail="{ item }">
                        <span v-if="item._send_mail=='success'">Oui</span>
                        <span v-else>Non</span>
                    </template>
                    <template v-slot:item._usermeanspaiement._means_paiement="{ item }">
                      <!--div class="author" >
                          <a class=" account-photo  account-product-owner ">
                              <div class="mask">
                                    <img :src="item._usermeanspaiement._means_paiement._file.substr(7)" alt="">
                              </div>
                          </a>
                      </div > -->
                        <span  style="cursor: pointer;color: #28B3A6" @click="userDetail(item)">
                          {{item._usermeanspaiement._means_paiement._name}}
                          ({{item._usermeanspaiement._means_paiement._country._name}}) :
                          {{item._usermeanspaiement._account_name}}
                          {{item._usermeanspaiement._account_surname}}
                         </span>

                    </template>
                    <template v-slot:item._usermeanspaiement._means_paiement._type="{ item }">
                        <v-chip :color="getColor(item._usermeanspaiement._means_paiement._type)" dark>{{ item._usermeanspaiement._means_paiement._type }}</v-chip>
                    </template>
                    <template v-slot:item._last_reversement_date="{ item }">
                      {{(item._last_reversement_date)? getDate(item._last_reversement_date):'--'}}
                    </template>
                    <template v-slot:item._created_at="{ item }">
                        {{ getDate(item._created_at)}}
                      </template>
                    <template v-slot:no-data>
                        {{$t('no_data')}}
                    </template>
                </v-data-table>
            </v-card>
        </div>

    </div>

</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import helpers from "@/mixins/helpers";

    export default {
        label: "PalierReversementConfigs",
      mixins:[helpers(this)],
        data() {
            return {
                submitting: false,
                reversing:false,
                responseMessage:'',
                responseError:'',
                valid: true,
                lazy: false,
                errors: undefined,
                errors_means: null,
                errors_montant: null,
                  dialogShowDetail:false,
                itemSteps: [
                    "Mois", "Trimestre", "Semestre"
                ],
                search: '',
                dialog: '',
                dialogNote: false,
                 note:"",
                id: undefined,
                step1: false,
                step2: false,
                step3: false,
                type: 'Mobile',
                e1: 1,
                detailuser: {},
                typesLists:['Mobile', 'Banque'],
                typesLists2:['bystep', 'byperiode'],
                headers: [
                    {
                        text: 'Source de réception',
                        align: 'start',
                        sortable: true,
                        value: '_usermeanspaiement._means_paiement',
                    },
                    {text: 'Type de la source', value: '_usermeanspaiement._means_paiement._type'},
                    {text: 'Numéro du compte', value: '_usermeanspaiement._account_number'},
                    {text: 'Montant', value: '_montant'},
                    {text: 'Période', value: '_periode'},
                    {text: 'Notification', value: '_send_mail'},
                    {text: 'Dernier reversement', value: '_last_reversement_date'},
                    {text: 'Date', value: '_created_at'},


                                    ],
                editedIndex: -1,
                editedItem: {
                    _type_transfert: 'bystep',
                    _montant: 1,
                    _periode: 'Mois',
                    _send_mail: '',
                    _marchand: '',
                    _usermeanspaiement: '',
                    _type_means: 'Mobile',
                    _id: 0,
                    _created_at: 0,
                },
                defaultItem: {
                  _type_transfert: 'bystep',
                  _montant: 1,
                  _periode: 'Mois',
                  _send_mail: '',
                  _marchand: '',
                  _usermeanspaiement: '',
                  _type_means: 'Mobile',
                  _id: 0,
                  _created_at: 0,
                },
                periodeRules: [
                    v => !!v || 'Période requise',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                type_transfertRules: [
                    v => !!v || 'Type requis',
                ]
                ,
                montantRules: [
                    v => !!v || 'Montant requis',
                ],
                usermeanspaiementRules: [
                    v => !!v || 'Moyen de paiement requis',
                ]

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? this.$t('reversements.newtext') : this.$t('reversements.update')
            }
            ,
            ...mapState('reversements/', ['reversements_configs']),

        }
        ,
        mounted() {



        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            },
            userDetail(item){
              this.detailuser = item._marchand;
              this.dialogShowDetail = true;
              console.log("this.detailuser",this.detailuser);

            },
          checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor(calories) {
              if (calories == "Banque") return 'green'
              else if (calories == "Mobile") return 'orange'
              else return 'green'
            },
            getColor2(calories) {
                if (calories == "en_attente") return 'orange'
                else if (calories == "success") return 'green'
                else return 'red'
            }
        }
        ,
        created() {
            this.checkisDashboard();
            this.initialize()
        }
    }
</script>

<style scoped>

</style>
